import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(
    product?.size ? product.size[0] : ""
  );

  if (!product) {
    return <div>Product not found</div>;
  }

  const handleAddToCart = () => {
    if (product.size && product.size.length > 0 && !selectedSize) {
      alert("Please select a size.");
      return;
    }
    addToCart(product.id, quantity, selectedSize);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const incrementQuantity = () => {
    setQuantity(quantity + 1);
  };

  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <div className="product-detail-page">
        {/* Breadcrumb Navigation */}
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span> / </span>
          <span>{product.name}</span>
        </div>

        <div className="product-detail-container">
          {/* Left Side - Product Images */}
          <div className="product-image-section">
            <div className="main-image-container">
              <img
                src={product.images[0]}
                alt={product.name}
                className="main-product-image"
              />
            </div>
          </div>

          {/* Right Side - Product Info */}
          <div className="product-info-section">
            <div className="product-brand">{product.country}</div>
            <h1 className="product-name">{product.name}</h1>

            <div className="product-price-section">
              <span className="product-price">${product.price} USD</span>
            </div>

            {/* Reviews */}
            <div className="product-reviews">
              <div className="stars">★★★★★</div>
              <span className="review-count">{product.reviews}</span>
            </div>

            {/* Customer Ratings */}
            <div className="customer-ratings">
              <span className="rating-icon">⭐</span>
              <span className="rating-text">
                Highly rated by customers for:{" "}
                <strong>scent, vanilla, oil</strong>
              </span>
            </div>

            {/* Size Selection */}
            {product.size && product.size.length > 0 && (
              <div className="size-selection">
                <label>SIZE:</label>
                <div className="sizes">
                  {product.size.map((size, index) => (
                    <button
                      key={index}
                      className={`size-btn ${
                        selectedSize === size ? "selected" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Quantity Selection */}
            <div className="quantity-selection">
              <label>QTY: ({quantity} IN CART)</label>
              <div className="quantity-control">
                <button onClick={decrementQuantity}>−</button>
                <input
                  type="number"
                  value={quantity}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (value >= 1) setQuantity(value);
                  }}
                />
                <button onClick={incrementQuantity}>+</button>
              </div>
            </div>

            {/* Add to Cart & Favorite Buttons */}
            <div className="action-buttons">
              <button className="add-to-cart-btn" onClick={handleAddToCart}>
                ADD TO CART
              </button>
            </div>

            {/* Trust Badges */}
            <div className="trust-badges">
              <div className="badge">
                <span className="badge-icon">✓</span>
                <span>100% Authentic</span>
              </div>
              <div className="badge">
                <span className="badge-icon">↺</span>
                <span>30 Day Return*</span>
              </div>
            </div>
          </div>
        </div>

        {/* Product Description Section */}
        <div className="product-description-container">
          <div className="description-left">
            <h2 className="description-title">The Sweetest Scent Around</h2>
            <div className="description-content">
              {product.description &&
                product.description.map((desc, index) => (
                  <p key={index}>{desc}</p>
                ))}
            </div>

            {product.Features && (
              <div className="fragrance-notes">
                {product.Features.map((fea, index) => (
                  <p key={index}>{fea}</p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductDetail;
